<template>
  <article class="lesta-cards">
    <div class="lesta-cards_content">
      <div class="lesta-cards_inner">
        <div class="lesta-cards__logo-wrap">
          <img
            class="lesta-cards__logo"
            src="./assets/logo.svg"
          >
        </div>
        <div class="lesta-cards__title">
          {{ $t('Выберите вашу страну для пополнения карты.') }}
        </div>
        <div class="lesta-cards__body">
          <ul class="lesta-cards_countries">
            <li class="country country--ru">
              <a
                :href="depositUrlTinkoff"
                class="country__link"
                @click="btnClick('ru')"
              >
                <span class="country__text"><b>{{ $t('Россия:') }}</b> {{ $t('Т-Банк') }}</span>
              </a>
            </li>
            <li class="country country--by">
              <a
                :href="depositUrlAlfaBy"
                class="country__link"
                @click="btnClick('by')"
              ><span class="country__text"><b>{{ $t('Беларусь:') }}</b> {{ $t('Альфа Банк') }}</span></a>
            </li>
          </ul>
          <div class="lesta-cards__info">
            {{ $t('* Пополнение осуществляется без комиссии со стороны выбранного банка') }}
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { getDepositUrl } from '@/helpers'
import { PARTNERS } from '@/constants'

@Component()
class SetCountry extends Vue {
  get depositUrlTinkoff () {
    return getDepositUrl(PARTNERS.TBANK)
  }
  get depositUrlAlfaBy () {
    return getDepositUrl(PARTNERS.ALFABANK_BY) || getDepositUrl(PARTNERS.ALPHA_BY)
  }
}

export default SetCountry
</script>

<style lang="scss">
  .lesta-cards {
    background-image: url("./assets/bg.jpg");
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;
    text-align: center;
    color: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 55px 20px;
    flex: 1;
    min-height: calc(100vh - 37px);
    box-sizing: border-box;

    &_content {
      display: flex;
      justify-content: center;
      align-items: center;

      padding-top: 65px;
      padding-bottom: 65px;
      @include media_tablet {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
    &_inner {
      max-width: 768px;
      margin-left: auto;
      margin-right: auto;
    }

    &__logo-wrap {
      margin-bottom: 27px;

      @include media_tablet {
        margin-bottom: 55px;
      }
    }
    &__logo {
      max-width: 125px;

      @include media_tablet {
        max-width: 180px;
      }
    }
    &__title {
      font-size: 20px;
      line-height: 1.2;
      margin-bottom: 35px;

      @include media_tablet {
        margin-bottom: 55px;
      }
    }
    &__body {
      max-width: 400px;
      margin-left: auto;
      margin-right: auto;
    }
    &__info {
      font-size: 16px;
      line-height: 1.2;
      color: #999;
      margin-top: 30px;

      @include media_tablet {
        margin-top: 50px;
      }
    }
  }
  .country {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    &__link {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      letter-spacing: 2px;
      color: #fff;
      border-radius: 10px;
      background-repeat: no-repeat;
      background-position: left center;
      background-size: cover;
      position: relative;
      text-decoration: none;
      letter-spacing: 0;

      @include media_desktop {
        will-change: opacity;
        opacity: 0.7;
        transition: 250ms;

        &:hover {
          opacity: 1;
          border-color: #999999;
          &:before {
            background: linear-gradient(
                270deg,
                #2b2826 50%,
                rgba(25, 23, 22, 0) 100%
            );
          }
        }
      }

      &:before {
        content: "";
        border: 1px solid #666;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 10px;
        background: linear-gradient(
            270deg,
            #1f1c1b 50%,
            rgba(25, 23, 22, 0.3) 100%
        );
        transition: 250ms;
      }

      &__just-border {
        > img {
          position: relative;
        }
        &:before {
          background: rgba(36, 33, 30, 0.5);
          border: 1px solid #666666;
          box-sizing: border-box;
          border-radius: 10px;
        }
        &:hover {
          &:before {
            background: rgba(61, 57, 52, 0.5);
            border: 1px solid #999999;
          }
        }
      }

      @include media_tablet {
        font-size: 24px;
      }

      .country--ru & {
        background-image: url(./assets/ru.png);
      }
      .country--by & {
        background-image: url(./assets/by.png);
      }
    }
    &__text {
      position: relative;
    }
  }
</style>
